import dashboardConfig1JSON from './config.dashboard2.json'

export default dashboardConfig1JSON;